import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import lockIcon from "../../assets/img/lockIcon.svg";
import "../../assets/css/admin/Login.css";
import { publicApiClient } from "../../api/apiClient";

export default function Login() {
  const navigate = useNavigate();

  const [id, setId] = useState("");
  const [pw, setPw] = useState("");
  const [keep, setKeep] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const clearAdminStorage = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("token");
    localStorage.removeItem("adminType");
    localStorage.removeItem("adminId");
    localStorage.removeItem("role");
    localStorage.removeItem("collegeId");
    localStorage.removeItem("userName");
    localStorage.removeItem("keepLogin");
  };

  const isAuditAdmin = ({ role, userLogin, userName }) => {
    const normalizedRole = String(role || "").toUpperCase();
    const normalizedLogin = String(userLogin || "").toLowerCase();
    const normalizedName = String(userName || "");

    return (
      normalizedRole === "AUDIT" ||
      normalizedRole === "AUDITOR" ||
      normalizedLogin === "admin_audit" ||
      normalizedLogin.includes("audit") ||
      normalizedName.includes("감사위원회")
    );
  };

  const getAdminType = ({ role, userLogin, userName }) => {
    const normalizedRole = String(role || "").toUpperCase();

    if (normalizedRole === "ADMIN") {
      return "stdcouncil";
    }

    if (isAuditAdmin({ role, userLogin, userName })) {
      return "audit";
    }

    if (normalizedRole === "COLLEGE") {
      return "cc";
    }

    return null;
  };

  const getRedirectPath = (adminType) => {
    if (adminType === "stdcouncil") {
      return "/stdcounciladmin/adminhome/intro/intro/current/student";
    }

    if (adminType === "cc") {
      return "/stdcounciladmin/adminhome/intro";
    }

    if (adminType === "audit") {
      return "/stdcounciladmin/adminhome/data/audit-committee";
    }

    return "/stdcounciladmin";
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const trimmedId = id.trim();

    if (!trimmedId || !pw) {
      setErrorMsg("아이디와 비밀번호를 입력해주세요.");
      return;
    }

    try {
      setLoading(true);
      setErrorMsg("");

      const result = await publicApiClient("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({
          userLogin: trimmedId,
          userPassword: pw,
        }),
      });

      const loginData = result?.data;

      if (!loginData) {
        setErrorMsg("로그인 응답 데이터가 없습니다.");
        return;
      }

      const {
        accessToken,
        userLogin,
        role,
        collegeId,
        userName,
      } = loginData;

      const loginId = userLogin || trimmedId;

      const adminType = getAdminType({
        role,
        userLogin: loginId,
        userName,
      });

      if (!accessToken) {
        setErrorMsg("로그인 토큰을 받지 못했습니다.");
        return;
      }

      if (!adminType) {
        setErrorMsg("관리자 권한 정보를 확인할 수 없습니다.");
        return;
      }

      clearAdminStorage();

      localStorage.setItem("accessToken", accessToken);
      localStorage.setItem("adminType", adminType);
      localStorage.setItem("adminId", loginId);
      localStorage.setItem("role", role || "");

      if (userName) {
        localStorage.setItem("userName", userName);
      }

      if (collegeId !== null && collegeId !== undefined) {
        localStorage.setItem("collegeId", String(collegeId));
      }

      if (keep) {
        localStorage.setItem("keepLogin", "true");
      }

      navigate(getRedirectPath(adminType), {
        replace: true,
      });
    } catch (error) {
      console.error("로그인 오류:", error);
      setErrorMsg(
        error.message || "서버 연결에 실패했습니다. 백엔드 실행 상태를 확인해주세요."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page" role="main">
      <div className="login-card">
        <h1 className="login-title">로그인</h1>
        <div className="login-underline" aria-hidden="true" />

        <form className="login-form" onSubmit={onSubmit}>
          <label htmlFor="loginId" className="login-label">
            아이디
          </label>

          <input
            id="loginId"
            className="login-input"
            type="text"
            placeholder="아이디를 입력하세요."
            value={id}
            onChange={(e) => setId(e.target.value)}
            autoComplete="username"
          />

          <label htmlFor="loginPw" className="login-label">
            비밀번호
          </label>

          <div className="login-input-wrap">
            <input
              id="loginPw"
              className="login-input"
              type="password"
              placeholder="비밀번호를 입력하세요."
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              autoComplete="current-password"
            />

            <img src={lockIcon} className="login-input-icon" alt="잠금" />

            {errorMsg && <p className="login-error">{errorMsg}</p>}
          </div>

          <label className="login-keep">
            <input
              type="checkbox"
              checked={keep}
              onChange={(e) => setKeep(e.target.checked)}
            />
            <span>로그인 상태유지</span>
          </label>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "로그인 중..." : "로그인"}
          </button>
        </form>
      </div>
    </div>
  );
}